export default (route, userRoles) => {
  const guardedRoute = route.matched.slice().reverse().find(route => route.meta && route.meta.guards)
  if (!guardedRoute) return { authorized: true }
  const guards = guardedRoute.meta.guards
  for (const {roles, redirect} of guards) {
    if (!roles) return { redirect }
    if (userRoles.some(userRole => roles.includes(userRole))) return redirect ? { redirect } : { authorized: true }
  }
  throw new Error('Cannot determine user access.')
}